"use client";
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from "react";
import classNames from "classnames";
import { Xmark } from "iconoir-react";
import { Dialog, DialogPanel } from "@headlessui/react";
/**
 * @deprecated Use the Dialog component instead for better accessibility and native browser support.
 * @see {@link Dialog}
 */
export const Modal = ({ children, className, buttonClassName, buttonText, hasCancel = false, cancelButtonClassName, buttonIcon, cancelButtonText = "Cancel", closeOnBackdropClick = true, disabled = false, onClose, }) => {
    const [isOpen, setIsOpen] = useState(false);
    const handleClose = () => {
        onClose?.();
        setIsOpen(false);
    };
    return (_jsxs(_Fragment, { children: [_jsxs("button", { className: buttonClassName, onClick: () => {
                    setIsOpen(true);
                }, disabled: disabled, children: [buttonIcon, buttonText] }), _jsxs(Dialog, { open: isOpen, onClose: () => {
                    if (closeOnBackdropClick) {
                        handleClose();
                    }
                }, children: [_jsx("div", { className: "fixed inset-0 bg-black/30", "aria-hidden": "true" }), _jsx("div", { className: "fixed inset-0 flex w-screen items-center justify-center p-4", children: _jsxs(DialogPanel, { className: classNames("relative min-h-[250px] min-w-[250px] rounded-xl bg-white px-4 py-6", className), children: [_jsx("button", { onClick: () => handleClose(), className: "absolute top-6 right-4 rounded-full bg-[#F2EFF0] p-2", children: _jsx(Xmark, {}) }), children, hasCancel && (_jsx("button", { onClick: () => handleClose(), className: cancelButtonClassName, children: cancelButtonText }))] }) })] })] }));
};
